
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            completedCourses: 'CompletedCourses/certificates',
        })
    },
    methods: {
        onCourseListChange (newList) {
            this.limitedCollection = newList
        },
        sortingChange (sortBy) {
            this.sorting = sortBy
        },
        onLearningPathListChange (newList) {
            this.filteredLearningPaths = newList
        },
        learningPathSortingChange (sortBy) {
            this.learningPathSorting = sortBy
        }
    },
    data () {
        return {
            limitedCollection: [],
            sorting: null,
            filteredLearningPaths: [],
            learningPathSorting: null
        }
    }
}
